
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * Service AuthService
 */
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { HttpClientService } from './httpClient.service';

@Injectable()
export class TemplateService {
  private _baseURL = "/api/templates";

  constructor(private _http: HttpClientService) {
  }

  getMine() {
    let url = this._baseURL + "/me";

    //noinspection TypeScriptValidateTypes
    return this._http.get(url).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  updateTemplate(contractor) {
    let url = this._baseURL;

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, contractor, headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }

  updateTemplates(profileId, templates) {
    let url = this._baseURL + '/' + profileId + '/collection';
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this._http.put(url, JSON.stringify({ collection: templates }), headers).pipe(
      map(res => res),
      catchError(this._handleError));
  }


  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
